import { KeyboardEvent, useEffect, useRef, useState } from "react";
import {
  Flex,
  Text,
  InputProps as ChakraInputProps,
  FormControl,
  Box,
  Image,
  Input as ChakraInput,
} from "@chakra-ui/react";
import {
  cellPhone,
} from "@/utils";
import { useCountries } from 'use-react-countries';
import useOutsideClick from "@/utils/outsideClick";
import { RiArrowDropDownLine } from "react-icons/ri";
import { ActionDrawerItem, DrawerList, Input as InputBarte } from "barte-design-system";
interface InputProps extends ChakraInputProps {
  name: string;
  label?: string;
  labelColor?: string;
  register?: any;
  defaultCountryCodeValue?: string;
  setValue: any;
  errors?: any;
  mask?: string;
  isDisabled?: boolean;
  optionalText?: string;
  tooltipText?: string;
  icon?: React.ReactNode;
  className?: string;
}

export function PhoneInput({
  name,
  setValue,
  label,
  labelColor,
  register,
  errors,
  mask,
  variant,
  color,
  isDisabled,
  defaultCountryCodeValue,
  optionalText,
  tooltipText,
  icon,
  className,
  ...rest
}: InputProps) {
  const { countries } = useCountries();
  const [selectedCountry, setSelectedCountry] = useState({} as any);
  const [isDropdownOpen,setIsDropdownOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const dropdownRef = useRef();
  const handleMaskInput = (e: KeyboardEvent<HTMLInputElement>) => {
    cellPhone(e);
  };
  const hasCallingCodeCountries = countries.filter(country => country.countryCallingCode !== "");
  const filteredCountries =  hasCallingCodeCountries.filter(country => country?.name?.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()));
  
  useOutsideClick(dropdownRef, () => {
    if (isDropdownOpen) {
      setIsDropdownOpen(false);
    }
  });

  function handleSelectCountry(country: any) {
    setSelectedCountry(country);
    setIsDropdownOpen(false);
  }

  useEffect(() => {
    const defaultCountryValue = countries.filter(country => country.countryCallingCode === defaultCountryCodeValue);
    setSelectedCountry(defaultCountryValue[0]);
  }, [defaultCountryCodeValue]);

  useEffect(() => {
    if(selectedCountry === undefined) return;
    setValue("countryCode", selectedCountry?.countryCallingCode);
  }, [selectedCountry]);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (register?.onChange) {
      register.onChange(e);
    }
    if (rest?.onChange) {
      rest.onChange(e);
    }
  };

  return (
    <FormControl isInvalid={!!errors?.message}>
      <Flex flexDir="column">
        <Box position="relative">
          <Box position="relative" display="inline-block" width="100%">
            <InputBarte
              onKeyUp={handleMaskInput}
              name={name}
              type="text"
              label={label}
              labelOptional={optionalText}
              helpText={tooltipText}
              error={errors?.message}
              icon={icon}
              className={className}
              disabled={isDisabled}
              onChange={handleChange}
              {...rest}
              {...(register || {})}
              style={{
                paddingLeft: "120px",
                ...rest?.style,
              }}
            />
            <Box
              position="absolute"
              left="8px"
              top={label ? "1.5rem" : "0.5rem"}
              zIndex={10}
              pointerEvents={isDisabled ? "none" : "auto"}
            >
              <button 
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setIsDropdownOpen(!isDropdownOpen);
                }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                disabled={isDisabled}
                style={{
                  cursor: isDisabled ? 'not-allowed' : 'pointer',
                  background: 'transparent',
                  border: 'none',
                  padding: "7px 0",
                  display: 'flex',
                  alignItems: 'center',
                  zIndex: 10
                }}
                type="button"
              >
                <Flex 
                  alignItems="center"
                  gap="2"
                  px="2"
                >
                  <Image 
                    w={6} 
                    h={4} 
                    src={selectedCountry?.flags?.png}
                  />
                  <Text>{selectedCountry?.countryCallingCode}</Text>
                  <RiArrowDropDownLine size={30}/>
                </Flex>
              </button>
            </Box>
          </Box>
          {isDropdownOpen && (
            <Box
              position="absolute"
              zIndex={10}
              top="calc(100% + .4rem)"
              ref={dropdownRef}
            >
              <DrawerList>
                <Box w="360px" maxW="90vw">
                  <Box px="2" pt="2" pb="1">
                    <ChakraInput
                      size="sm"
                      borderRadius="var(--border-radius-sm)"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      placeholder="Pesquisar país"
                      isDisabled={isDisabled}
                    />
                  </Box>
                  <Box maxH="300px" overflowY="auto">
                    {filteredCountries?.map((country) => (
                      <ActionDrawerItem
                        key={country.name}
                        variant="icon"
                        icon={<Image w={6} h={4} src={country.flags.png} />}
                        label={`${country.countryCallingCode} (${country.name})`}
                        onClick={() => handleSelectCountry(country)}
                      />
                    ))}
                  </Box>
                </Box>
              </DrawerList>
            </Box>
          )}
        </Box>
      </Flex>
    </FormControl>
  );
}
